import { useEffect } from 'react';
import { logEvent } from '@utils/takt';
import { useLocation } from 'react-router-dom';

/**
 * There is an issue with the OPF redirections to SAR, currently,
 * the @RequestMapping in ARMS isn't catching the following routes:
 *   '/gateway'
 *   '/gateway/sso/register',
 *   '/registration/kdp/gateway',
 * This is a fallback in case we load the UI application using the AR routes.
 */
function GatewayRegistrationRedirect() {
  const location = useLocation();
  const LOG_EVENT_ID = 'GatewayRegistrationRedirection';
  useEffect(() => {
    logEvent(LOG_EVENT_ID, { route: location.pathname });
    window.location.href = '/ads-account/registration';
  }, []);

  return null;
}

export default GatewayRegistrationRedirect;
